export const optionTransaction = [
  { value: "", label: "Semua Jenis Transaksi" },
  { value: 1, label: "Terbayar" },
  { value: 0, label: "Belum Bayar" },
];
